// eslint-disable-next-line
import { useState, useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Footer from "./Footer.jsx";
import { UserContext } from "../contexts";
import { Stack, Typography, Divider, Popover } from "@mui/material";

export default function Main({ self, set_self, logout }) {
  const sx = {
    wrapper: { width: 1, alignItems: "center" },
    container: {
      width: "calc(100% - 30px)",
      p: "15px",
      minHeight: "100vh",
      alignItems: "center",
    },
  };

  return (
    <UserContext.Provider value={{ self, set_self, logout }}>
      <Stack sx={sx.wrapper} divider={<Divider flexItem />}>
        <Navigation />

        <Stack sx={sx.container}>
          <Outlet />
        </Stack>

        <Footer />
      </Stack>
    </UserContext.Provider>
  );
}

function Navigation() {
  const sx = {
    wrapper: {
      width: "calc(100% - 10px)",
      p: "5px",
      justifyContent: "space-between",
    },
  };
  const navigate = useNavigate();
  const btns = [
    { route: "/", title: "Cybersecurity" },
    { route: "/nopage", title: "Team [DEV]" },
    { route: "/scans", title: "Scans" },
  ];

  return (
    <Stack direction="row" sx={sx.wrapper} spacing={2}>
      <Stack direction="row" spacing={2}>
        {btns.map((e, i) => (
          <Typography key={i} onClick={() => navigate(e.route)} sx={gsx.btn}>
            {e.title}
          </Typography>
        ))}
      </Stack>

      <AuthBtn />
    </Stack>
  );
}

function AuthBtn() {
  const { logout } = useContext(UserContext);
  // eslint-disable-next-line
  const navigate = useNavigate();

  const [anchor, set_anchor] = useState();
  const open_popover = (e) => set_anchor(e.currentTarget);
  const close_popover = () => set_anchor();
  function on_click(url) {
    close_popover();
    navigate(url);
  }

  let btns = [
    { route: "/", title: "Upgrade to Pro [DEV]" },
    { route: "/account", title: "Account" },
  ];

  const sx = {
    anchororigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformorigin: {
      vertical: "top",
      horizontal: "right",
    },
    container: { p: 1 },
  };

  return (
    <>
      <Typography onClick={open_popover} sx={gsx.btn}>
        Account
      </Typography>

      <Popover
        open={anchor !== undefined}
        anchorEl={anchor}
        onClose={close_popover}
        anchorOrigin={sx.anchororigin}
        transformOrigin={sx.transformorigin}
      >
        <Stack sx={sx.container} spacing={1}>
          {btns.map((e, i) => (
            <Typography key={i} sx={gsx.btn} onClick={() => on_click(e.route)}>
              {e.title}
            </Typography>
          ))}
          <Divider flexItem />
          <Typography sx={gsx.btn} onClick={logout}>
            Logout
          </Typography>
        </Stack>
      </Popover>
    </>
  );
}

const gsx = {
  btn: {
    cursor: "pointer",
    "&:hover": { backgroundColor: "lightgrey" },
    p: 1,
  },
};
